import { DATADOG_CLIENT_TOKEN, IS_PRODUCTION, IS_VERCEL } from '../constants/env'

let isInitialized = false
let datadogLogs: typeof import('@datadog/browser-logs').datadogLogs | undefined
let initPromise: Promise<void> | undefined

export const initDatadog = () => {
  if (isInitialized || !DATADOG_CLIENT_TOKEN) {
    return Promise.resolve()
  }

  if (initPromise) {
    return initPromise
  }

  initPromise = import('@datadog/browser-logs').then(({ datadogLogs: loadedDatadogLogs }) => {
    const runningInEnv = IS_PRODUCTION ? 'production' : IS_VERCEL ? 'preview' : 'local'

    loadedDatadogLogs.init({
      clientToken: DATADOG_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'website',
      env: runningInEnv,
      sessionSampleRate: 100,
    })

    datadogLogs = loadedDatadogLogs
    isInitialized = true
  })

  return initPromise
}

export const logError = (message: string, context?: Record<string, unknown>) => {
  if (!isInitialized || !datadogLogs) {
    return
  }

  datadogLogs.logger.error(message, context)
}

export const logWarning = (message: string, context?: Record<string, unknown>) => {
  if (!isInitialized || !datadogLogs) {
    return
  }

  datadogLogs.logger.warn(message, context)
}

export const logInfo = (message: string, context?: Record<string, unknown>) => {
  if (!isInitialized || !datadogLogs) {
    return
  }

  datadogLogs.logger.info(message, context)
}
